<template>
  <div class="google-login-root">
    <div class="google-login-card">
      <div class="google-login-top">
        <div class="google-login-brand">
          <div class="google-login-gmark" aria-hidden="true">G</div>
          <div v-if="googleUser" class="google-login-user">
            <div class="google-login-name">{{ googleUser.name }}</div>
            <div class="google-login-email">{{ googleUser.email }}</div>
          </div>
          <div v-else class="google-login-user">
            <div class="google-login-name google-login-name--placeholder">
              No account connected
            </div>
            <div class="google-login-email google-login-email--placeholder">
              Connect your Google account to continue
            </div>
          </div>
        </div>
        <div class="google-login-actions">
          <span v-if="googleUser" class="connected-badge">Connected</span>
          <google-button compact />
        </div>
      </div>
      <div class="google-login-banner">
        <i class="material-icons-outlined google-login-banner__icon" aria-hidden="true">lock</i>
        <span>We only access Google Search Console data. Nothing else.</span>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleButton from '@/components/Campaigns/GoogleButton.vue';
import { EventEmitter } from '@/utils/Event.js';

export default {
  components: {
    GoogleButton,
  },
  data () {
    return {
      googleUser: null,
    };
  },
  mounted () {
    this.syncFromStore();
    EventEmitter.subscribe('GOOGLE_USER_UPDATE', (googleUser) => {
      // payload is the plain store shape: { name, email, profileImg }
      if (!googleUser || !googleUser.email) {
        this.googleUser = null;
        return;
      }
      this.googleUser = {
        name: googleUser.name || googleUser.email,
        email: googleUser.email,
        profileImg: googleUser.profileImg || null,
      };
    });
  },
  methods: {
    syncFromStore () {
      const u = this.$store.state.googleUser;
      if (u && u.name) {
        this.googleUser = {
          name: u.name,
          email: u.email || '',
          profileImg: u.profileImg,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.google-login-root {
  width: 100%;
  max-width: 520px;
}

.google-login-card {
  border: 1px solid #e0e4ea;
  background: #fff;
  border-radius: 10px;
  padding: 18px 20px 16px;
}

.google-login-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.google-login-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex: 1;
}

.google-login-gmark {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #2d66ff;
  color: #fff;
  font-weight: 700;
  font-size: 1.15rem;
  line-height: 40px;
  text-align: center;
  font-family: inherit;
}

.google-login-user {
  min-width: 0;
}

.google-login-name {
  font-weight: 700;
  font-size: 0.95rem;
  color: #003d4d;
  line-height: 1.3;
  word-break: break-word;
}

.google-login-name--placeholder {
  color: #4a6570;
}

.google-login-email {
  margin-top: 2px;
  font-size: 0.85rem;
  font-weight: 400;
  color: #5a7a85;
  line-height: 1.35;
  word-break: break-all;
}

.google-login-email--placeholder {
  color: #6b8794;
}

.google-login-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.connected-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #34a853;
  background: #e6f7ed;
  border: 1px solid #34a853;
  white-space: nowrap;
}

.google-login-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  padding: 10px 12px;
  background: #f5f6fa;
  border-radius: 8px;
  color: #5c6470;
  font-size: 0.8125rem;
  line-height: 1.45;
}

.google-login-banner__icon {
  flex-shrink: 0;
  font-size: 1.125rem;
  color: #7a8494;
}
</style>
